<template>
    <base-template>
        <header class="header header-home">
            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <div class="cell">
                        <div class="header-home__content">
                            <img
                                class="header-home__logo"
                                src="@/assets/img/logos/ijstijd.svg"
                                alt="ijstijd">

                            <h1>Zoek jouw droomactiviteit</h1>

                            <div class="header__intro">
                                En verzilver je unieke IJSTIJD! code!
                            </div>
                        </div>

                        <div class="filter-bar">
                            <img
                                class="filter-bar__figure"
                                src="@/assets/img/content/guy_full.png" >

                            <h2 class="h5 filter-bar__title">Wat wil je graag doen?</h2>

                            <form class="filter-bar__form">
                                <div class="grid-x grid-padding-x align-bottom">
                                    <div class="cell medium-auto">
                                        <div class="grid-x grid-padding-x small-up-1 medium-up-3">
                                            <div class="cell">
                                                <location-field
                                                    label="Plaats"
                                                    v-model="filters.city"
                                                    placeholder="Typ plaats" />
                                            </div>
                                            <div class="cell">
                                                <select-field
                                                    label="Activiteit"
                                                    v-model="filters.activityType">

                                                    <option
                                                        :value="null"
                                                        selected>
                                                        Selecteer een activiteit
                                                    </option>

                                                    <option
                                                        v-for="(activitytype, index) in $store.state.products.filterValues.activityTypes"
                                                        :value="index"
                                                        :key="index">
                                                        {{ activitytype }}
                                                    </option>
                                                </select-field>
                                            </div>
                                            <div class="cell">
                                                <date-field
                                                    label="Datum"
                                                    :options="{minDate: 'today', allowEmpty: true}"
                                                    placeholder="Selecteer datum"
                                                    :value="filters.date"
                                                    v-model="filters.date" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cell medium-shrink">
                                        <button
                                            class="btn btn--white"
                                            @click.prevent="search()">
                                            Zoeken!
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div class="activity-counter">
                            <div
                                class="activity-counter__inner"
                                data-sticky-class="activity-counter__inner--sticky">
                                <span>
                                    {{ activitiesFoundText }}
                                    <button
                                        v-if="filtersActive"
                                        @click="resetFilters()"
                                        class="btn btn--white btn--small">
                                        Toon alles
                                    </button>
                                </span>

                                <div class="activity-counter__backtotop">
                                    <a
                                        @click="backToTop()"
                                        class="btn-back">
                                        <i class="icon-arrow_up" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <section
            class="article-listener"
            v-if="$store.state.products">
            <div class="grid-container">
                <div
                    class="panel panel--no-results"
                    v-if="$store.state.products.noresults">
                    <h2>Uitglijder!</h2>
                    <h3>We kunnen jouw activiteit niet vinden</h3>
                    <p>Onze aanbieders zijn constant bezig met het toevoegen van nieuwe IJSTIJD! activiteiten. Probeer het later nog eens.</p>
                </div>

                <div class="grid-x grid-margin-x grid-margin-y small-up-1 medium-up-2 large-up-3">
                    <article-block
                        v-for="(product, index) in $store.state.products.items"
                        :key="index"
                        class="cell article-block"
                        :product="product"
                        :campaign="campaign"/>
                </div>

                <div
                    class="grid-x"
                    v-if="$store.state.products.nextpage">
                    <div class="cell">
                        <InfiniteLoader
                            :url="$store.state.products.nextpage"
                            :offset="300"
                            @hit="loadNext()" />
                    </div>
                </div>
            </div>
        </section>
    </base-template>
</template>

<script>
import BaseTemplate from '@/components/base/BaseTemplate.vue';
import ArticleBlock from '@/components/ArticleBlock.vue';
import InfiniteLoader from '@/components/InfiniteLoader.vue';
import Sticky from 'sticky-js';
import { mapActions } from 'vuex';
import { TweenLite } from 'gsap';

export default {
    data() {
        return {
            loading: false,
            filters: {
                city: null,
                activityType: null,
                date: null,
                campaign: this.$route.params.campaign
            },
        };
    },
    components: {
        BaseTemplate,
        ArticleBlock,
        InfiniteLoader,
    },
    computed: {
        campaign() {
            return this.$route.params.campaign;
        },
        activitiesFoundText() {
            const nrOfActivities = this.$store.state.products.totalItemsAvailable || 0;

            if(nrOfActivities === 1) {
                return `1 activiteit gevonden`;
            }

            return `${nrOfActivities} activiteiten gevonden`;
        },
        filtersActive() {
            let hadSomeFiltering = false;

            Object.entries(this.$store.state.products.filters).forEach((item) => {
                if((item[0] !== 'city' && item[1]) || (item[1] && item[0] === 'city' && item[1].lat !== null)) {
                    hadSomeFiltering = true;
                }
            });

            return hadSomeFiltering;
        }
    },
    mounted() {
        new Sticky('.activity-counter .activity-counter__inner');
    },
    watch: {
        $route: 'fetchItems',
    },
    created() {
        if(!this.$store.state.products.filters?.city?.value) {
            if(this.$route.query.lng && this.$route.query.lat && this.$route.query.plaats) {
                this.filters.city = {
                    lng: this.$route.query.lng || null,
                    lat: this.$route.query.lat || null,
                    value: this.$route.query.plaats || null
                };

                this.prefillFilters(this.filters);
            }
        }

        this.fetchItems();
    },
    methods: {
        ...mapActions({
            'getProducts': 'products/getProducts',
            'getMoreProducts': 'products/getMoreProducts',
            'setFilters': 'products/setFilters',
            'prefillFilters': 'products/prefillFilters',
        }),
        fetchItems() {
            this.getProducts({partner: false, campaign: this.$route.params.campaign});

            this.filters.campaign = this.$route.params.campaign;
            this.filters.city = this.$store.state.products.filters.city;
            this.filters.date = this.$store.state.products.filters.date;
            this.filters.activityType = this.$store.state.products.filters.activityType;
        },
        loadNext() {
            this.getMoreProducts();
        },
        search() {
            this.setFilters(this.filters).then(() => {
                return this.getProducts({partner: false, campaign: this.$route.params.campaign});
            }).then(() => {
                this.scrollToArticles();

                if(this.$store.state.products.noresults) {
                    this.getProducts({partner: false, campaign: this.$route.params.campaign});
                }
            });
        },
        backToTop() {
            TweenLite.to('body, html', 0.3, {scrollTop: 0});
        },
        scrollToArticles() {
            const rect = this.$el.querySelector('.article-listener').getBoundingClientRect();
            TweenLite.to('body, html', 0.3, {scrollTop: document.documentElement.scrollTop + rect.top - 80});
        },
        resetFilters() {
            this.filters.city = {
                lat: null,
                lng: null,
                value: null
            };
            this.filters.date = null;
            this.filters.activityType = null;
            this.search();
        },
        destroy() {
            TweenLite.killTweensOf('body, html');
        }
    },
};
</script>
